import { useState, MouseEvent } from "react"
import { useSelector } from "react-redux"
import { Menu, MenuItem, IconButton } from "@mui/material"

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import {
  ActiveIcon,
  AchivedIcon,
  MissedIcon,
} from "../../Table/OpportunityDashboardTable/Atom"

import OpportunityDashboardStatusUpdate from "../../Modal/OpportunityDashboardStatusUpdate"

export default function OpportunityStatusMenu(props: any) {
  const { valueToApply, row, updateStatus, dateFilterHandler } = props

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleConfimClose = () => {
    SetOpened(false)
  }
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [opened, SetOpened] = useState(false)
  const [updateData, setUpdateData] = useState({})
  const [selectedStatus, setSelectedStatus] = useState("")
  const open = Boolean(anchorEl)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const opportunityStatuses = useSelector((state: any) => {
    return state.opportunity.opportunityStatuses
  })

  const opportunityFetchId = useSelector((state: any) => {
    return state.metric.opportunityFetchId
  })

  const status = opportunityStatuses.filter((ele: any) => {
    if (ele.status !== valueToApply && ele.status !== "all") {
      return ele
    }
  })

  return (
    <div>
      <OpportunityDashboardStatusUpdate
        opened={opened}
        handleConfimClose={handleConfimClose}
        updateData={updateData}
        selectedStatus={selectedStatus}
        updateStatus={updateStatus}
      />
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        disableRipple
        sx={{ p: 0 }}
      >
        <KeyboardArrowDownIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {status?.map((status: any, index: any) => {
          return (
            <MenuItem
              key={index}
              onClick={() => {
                SetOpened(true)
                handleClose()
                // console.log("status.status ", status.status)
                setUpdateData({ id: opportunityFetchId, status: status.status })
                setSelectedStatus(status.status)
              }}
              sx={{
                backgroundColor:
                  status.status === "achieved"
                    ? "#42B2A01A"
                    : status.status === "missed"
                    ? "#F158541A"
                    : status.status === "active"
                    ? "#3366D61A"
                    : "",
                margin: "8px 10px",
              }}
            >
              {status.status === "achieved" ? (
                <AchivedIcon />
              ) : status.status === "missed" ? (
                <MissedIcon />
              ) : status.status === "active" ? (
                <ActiveIcon />
              ) : (
                ""
              )}
              &nbsp; &nbsp;
              <span
                style={{
                  color:
                    status.status === "achieved"
                      ? "#42B2A0"
                      : status.status === "missed"
                      ? "#F15854"
                      : status.status === "active"
                      ? "#3366D6"
                      : "",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {status.label}
              </span>
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
